<template src='./funding-adequacy-indicator.html'></template>

<script>
import tabulatorMixin from '@/mixins/tabulator'
import Tabulator from '@/components/tabulator/Tabulator'
import Vue from 'vue'
import HighlightButton from '@/components/misc/HighlightButton.vue'
import { EventBus } from '@/router/bus'

export default {
  components: {
    Tabulator,
    HighlightButton
  },
  mixins: [tabulatorMixin],
  props: ['data', 'project', 'selectedPhase', 'projectCode', 'projectPhaseId'],
  data () {
    return {
      indicator: {},
      displayResetButton: false,
      tabulatorOptions: {
        ajaxSorting: false,
        ajaxFiltering: false,
        pagination: false,
        paginationSize: undefined,
        ajaxURLGenerator: undefined,
        headerSortElement: '',
        footerElement: '',
        layout: 'fitColumns',
        columns: [
          {
            title: 'Г',
            field: 'year',
            hozAlign: 'right',
            headerHozAlign: 'right',
            headerTooltip: 'Година',
            formatter: (cell, formatterParams, onRendered) => {
              return '<b>' + cell.getValue() + '</b>'
            },
            minWidth: 50
          },
          {
            title: 'К',
            field: 'quarter',
            hozAlign: 'right',
            headerHozAlign: 'right',
            headerTooltip: 'Квартал',
            formatter: (cell, formatterParams, onRendered) => {
              return '<b>' + cell.getValue() + '</b>'
            },
            minWidth: 50
          },
          {
            title: 'ПАФ',
            field: 'value',
            hozAlign: 'right',
            formatter: 'money',
            cssClass: 'bold-text',
            headerHozAlign: 'right',
            headerTooltip: 'Показатељ адекватности финансирања (ПАФ - квартални)',
            formatterParams: {
              decimal: ',',
              thousand: '.',
              symbol: '',
              symbolAfter: '',
              precision: 2
            },
            minWidth: 100
          },
          {
            title: 'ЗA',
            field: 'appropriationAmount',
            hozAlign: 'right',
            formatter: 'money',
            headerHozAlign: 'right',
            cssClass: 'bold-text',
            headerTooltip: 'Збир свих буџетских апропријација за КП на годишњем нивоу',
            formatterParams: {
              decimal: ',',
              thousand: '.',
              symbol: '',
              symbolAfter: '',
              precision: 2
            },
            minWidth: 150
          },
          {
            title: 'ПA',
            field: 'remainingAppropriationAmount',
            hozAlign: 'right',
            formatter: 'money',
            cssClass: 'bold-text',
            headerHozAlign: 'right',
            headerTooltip: 'Преостали износ буџетских апропријација по фискалној години (номинално)',
            formatterParams: {
              decimal: ',',
              thousand: '.',
              symbol: '',
              symbolAfter: '',
              precision: 2
            },
            minWidth: 150
          },
          {
            title: 'ПA %',
            field: 'remainingAppropriationPercent',
            hozAlign: 'right',
            formatter: 'money',
            cssClass: 'bold-text',
            headerHozAlign: 'right',
            headerTooltip: 'Преостали износ буџетских апропријација по фискалној години (процентуално)',
            formatterParams: {
              decimal: ',',
              thousand: '.',
              symbol: '',
              symbolAfter: '',
              precision: 2
            },
            minWidth: 150
          },
          {
            title: 'ГВ ПАФ',
            field: 'limitReached',
            hozAlign: 'right',
            headerHozAlign: 'right',
            headerTooltip: 'ГРАНИЧНА ВРЕДНОСТ ПАФ',
            formatter: (cell, formatterParams, onRendered) => {
              return cell.getValue() ? '<b>' + this.$t('successKeyIndicator.limitReached') + '</b>' : '<b>' + this.$t('successKeyIndicator.ok') + '</b>'
            },
            minWidth: 150
          }
        ]
      }
    }
  },
  computed: {
    getColor () {
      return this.project.phase === this.selectedPhase.phase ? 'var(--v-cards-base)' : 'var(--v-success-light-base)'
    }
  },
  methods: {
    calculate () {
      this.showLoader(true)
      this.$http.post(Vue.$apiConfig.calculateSuccessKeyIndicatorPost, { FundingAdequacyIndicator: this.data })
        .then(
          response => {
            this.logConsole(response)
            const payload = response.data.payload
            this.reloadData(payload.fundingAdequacyIndicator)
            this.displayResetButton = true
            this.showLoader(false)
          },
          error => {
            this.formatErrorResponse(error)
            this.showLoader(false)
          }
        )
    },
    reset () {
      this.showLoader(true)
      this.$http.get(Vue.$apiConfig.successKeyIndicatorGet.replace('{projectCode}', this.projectCode).replace('{projectPhaseId}', this.projectPhaseId))
        .then(
          response => {
            this.logConsole(response)
            this.reloadData(response.data.payload.map(x => x.fundingAdequacyIndicator))
            this.displayResetButton = false
            this.showLoader(false)
          },
          error => {
            this.formatErrorResponse(error)
            this.showLoader(false)
          }
        )
    },
    reloadData (data) {
      EventBus.$emit('reloadFundingAdequacyIndicatorData', data)
    },
    showLoader  (loader) {
      EventBus.$emit('projectLoader', loader)
    }
  }
}
</script>
<style>
  .bold-text {
    font-weight: bold;
  }
  .tabulator .tabulator-header .tabulator-col.tabulator-sortable .tabulator-col-title {
    padding-right: 0px !important;
  }
</style>
